export default __webpack_public_path__ + "static/media/Acoer-Trademark-Logo-Light-Mode.2db79665.svg";